<template>
  <Container>
    <ShareLink class="js-social-share" :href="twitterLink" rel="nofollow" target="_blank">
      <TwitterIcon />
      <ScreenReaderText>Share on Twitter</ScreenReaderText>
    </ShareLink>
    <ShareLink class="js-social-share" :href="facebookLink" rel="nofollow" target="_blank">
      <FacebookIcon />
      <ScreenReaderText>Share on Facebook</ScreenReaderText>
    </ShareLink>
    <ShareLink class="js-social-share" :href="linkedInLink" rel="nofollow" target="_blank">
      <LinkedInIcon />
      <ScreenReaderText>Share on LinkedIn</ScreenReaderText>
    </ShareLink>
    <ShareLink :href="emailLink" rel="nofollow">
      <EmailIcon />
      <ScreenReaderText>Share via Email</ScreenReaderText>
    </ShareLink>
  </Container>
</template>

<script>
import {
  Container,
  TwitterIcon,
  FacebookIcon,
  LinkedInIcon,
  EmailIcon,
  ShareLink,
  ScreenReaderText,
} from './shareIcons.styles';

export default {
  components: { Container, TwitterIcon, FacebookIcon, LinkedInIcon, EmailIcon, ShareLink, ScreenReaderText },
  data() {
    return {
      twitterLink: `https://twitter.com/intent/tweet/?text= ${encodeURI(document.title)}&url=${encodeURI(
        window.location.href
      )}&via=AsiaMattersEWC`,
      facebookLink: `https://www.facebook.com/sharer.php?u=${encodeURI(window.location.href)}`,
      linkedInLink: `http://www.linkedin.com/shareArticle?mini=true&url=${encodeURI(
        window.location.href
      )}&title=${encodeURI(document.title)}&source=${encodeURI(window.location.origin)}`,
      emailLink: `mailto:?subject=${encodeURI(document.title)}&body=${encodeURI(document.title)}%0A${encodeURI(
        window.location.href
      )}`,
    };
  },
};
</script>
